export default "__VITE_ASSET__M3lBzndw__"